// shim
require('regenerator-runtime/runtime')

if (window.location.origin == null) {
  window.location.origin = `${window.location.protocol}//${window.location.hostname}`
  if (window.location.port != null) window.location.origin += `:${window.location.port}`
}

const hub = require('./odo/odojs/').hub()
const request = require('superagent')
const dynamic = require('./odo/odoql-exe/dynamic')
const Store = require('./odo/odoql-store')
const localstore = Store({ name: 'localstore' })
let exe = require('./odo/odoql-exe/')
exe = exe({ hub })
  .use(localstore)
  .use(
    dynamic((keys, queries, cb) => {
      request
        .post('/marketing/query')
        .send({ q: queries })
        .set('Accept', 'application/json')
        .end((err, res) => {
          var i, key, len
          if (err != null) return cb(err)
          if (!res.ok) return cb(new Error(res.text))
          const result = {}
          for (const key of keys) result[key] = res.body[key]
          cb(null, result)
        })
    })
  )

require('./marketing/')
require('./shared/')

// Setup odo relay against the root router component
// Discover queries, state and dom elements already built on the server
const relay = require('./odo/odo-relay')
const router = require('./shared/router')
const root = document.querySelector('#root')
const scene = relay(root, router, exe, { hub })

// Load routes into page.js for pushstate routing
const route = require('odo-route')
const page = require('page')
const hostname = window.location.hostname
const hostnameparts = hostname.split('.')
const subdomain = hostnameparts.length === 3 ? hostnameparts[0] : null

page('*', (e, next) => {
  scene.clearParams()
  next()
  window.scrollTo(0, 0)
})

for (const r of route.routes())
  page(r.pattern, (e, next) => {
    const context = {
      hostname: hostname,
      subdomain: subdomain,
      url: e.pathname,
      params: e.params,
      querystring: e.querystring
    }
    let callednext = false
    const result = r.cb(context, () => {
      callednext = true
      next()
    })
    if (!callednext) hub.emit('update', result)
  })

// Log all events
hub.all((e, description, p, cb) => {
  // for (const n of ['odo', 'Odo'])
  //   if (description.indexOf(n) !== -1) return cb()
  // if (description === 'update') return cb()
  // console.log(description, p)
  cb()
})
;(xhr => {
  xhr.active = 0
  const pt = xhr.prototype
  const _send = pt.send
  pt.send = function () {
    xhr.active++
    this.addEventListener('readystatechange', e => {
      if (this.readyState === 4) setTimeout(() => xhr.active--, 1)
    })
    _send.apply(this, arguments)
  }
})(XMLHttpRequest)

const addtouch = e => {
  document.documentElement.classList.remove('notouch')
  document.removeEventListener('touchstart', addtouch, false)
}
document.addEventListener('touchstart', addtouch, false)

const intents = [require('./marketing/intent'), require('./shared/intent')]

for (const intent of intents) intent(hub, scene, localstore)

hub.every('update', (p, cb) => {
  scene.update(p)
  cb()
})

// Detect the current url and run scene.update for the first time
page.start()
